import { useCallback, useEffect, useState } from 'react';
import { message } from 'antd';
import * as adminApi from '../../../../services/api/adminApi';
import { getErrorMessage } from '../../../../utils/apiError';

export default function useAdminUsers() {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchUsers = useCallback(() => {
        setLoading(true);
        adminApi.fetchUsers()
            .then(data => setUsers(data.users || []))
            .catch(err => message.error(getErrorMessage(err, 'Failed to load users')))
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        fetchUsers();
    }, [fetchUsers]);

    const runMutation = async (action, successMessage, failureMessage) => {
        try {
            await action();
            message.success(successMessage);
            fetchUsers();
            return true;
        } catch (err) {
            message.error(getErrorMessage(err, failureMessage));
            return false;
        }
    };

    const saveUser = (editingUser, values) =>
        editingUser
            ? runMutation(() => adminApi.updateUser(editingUser.id, values), 'User updated successfully', 'Failed to save user')
            : runMutation(() => adminApi.createUser(values), 'User created successfully', 'Failed to save user');

    const deleteUser = (id) =>
        runMutation(() => adminApi.deleteUser(id), 'User deleted successfully', 'Failed to delete user');

    const toggleAdmin = (targetUser) =>
        runMutation(
            () => adminApi.updateUser(targetUser.id, { is_admin: !targetUser.is_admin }),
            'User admin status updated',
            'Failed to update user'
        );

    return { users, loading, fetchUsers, saveUser, deleteUser, toggleAdmin };
}
